import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import tracker from 'utils/tracker';

import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import { getBalancesByAccountId } from 'data/accountBalances/selectors';
import { getAccountsById } from 'data/accounts/selectors';
import { getReconcileInfoForAccount } from 'data/reconcileList/selectors';
import { isActiveConnectedAccountFromId } from 'data/accounts/utils';

import QDialogs from 'components/QDialogs';

import { styles } from './styles';
import { ReconcileSetup } from './reconcileSetup';
import ReconcileWorkspace from './reconcileWorkspace';

// ==============================================================
//
// Presents the form to bulk edit a group of transactions
//
//
export class ReconcilePanel extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      statementEndDate: null,
      statementEndBalance: null,
      showSetup: true,
      useOnline: false,
    };

    if (!this.props.reconcileInfo) {
      this.closeAndExit();
    }
  }

  componentDidMount() {
  }

  setInitialFocus = () => {
  };

  closeAndExit = (status) => {

    if (status && status !== 'canceled') {
      //
      // send mixpanel event
      //
      tracker.track(tracker.events.reconcileAnAccount, {
        method: this.state.useOnline ? 'Online Balance' : 'Paper Statement',
        status,
      });
    }
    this.props.onClose();
  };

  onSave = (data) => {
    //
    // send mixpanel event
    //
    tracker.track(tracker.events.reconcileAnAccount, {
      method: data.useOnline ? 'Online Balance' : 'Paper Statement',
      status: 'Started',
    });

    this.setState(
      {
        useOnline: data.useOnline,
        showSetup: false,
        statementEndDate: data.statementEndDate,
        statementEndBalance: data.statementEndBalance,
      }
    );
  };


  render() {

    const { classes } = this.props;
    const { showSetup } = this.state;

    if (!this.props.reconcileInfo) {
      this.props.dialogAlert(
        'There are no transactions to reconcile',
        '',
        null,
        ['Got It'],
        'info',
      );
      return null;
    }
    return (
      <>
        {showSetup &&
          <ReconcileSetup
            accountBalances={this.props.accountBalances}
            account={this.props.accountRecord}
            isOnline={isActiveConnectedAccountFromId(this.props.accountId)}
            lastReconciledBalance={this.props.reconcileInfo.get('registerReconciledBalance')}
            onSave={this.onSave}
            onClose={this.closeAndExit}
            classes={classes}
          />
        }
        {!showSetup &&
          <ReconcileWorkspace
            account={this.props.accountRecord}
            statementEndDate={this.state.statementEndDate}
            statementEndBalance={Number(this.state.statementEndBalance)}
            onClose={this.closeAndExit}
            classes={classes}
          />
        }
      </>
    );
  }
}

ReconcilePanel.propTypes = {
  accountId: PropTypes.string,
  onClose: PropTypes.func,
  classes: PropTypes.object,
  accountBalances: PropTypes.object,
  accountRecord: PropTypes.object,
  reconcileInfo: PropTypes.object,

  dialogAlert: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  return {
    accountBalances: getBalancesByAccountId(state).get(ownProps.accountId),
    accountRecord: getAccountsById(state).get(ownProps.accountId),
    reconcileInfo: getReconcileInfoForAccount(state,
      {
        accountId: ownProps.accountId,
        statementDate: isActiveConnectedAccountFromId(ownProps.accountId) ? null : moment().format('YYYY-MM-DD'),
        statementEndingBalance: 0,
      }),
  };
}

function mapDispatchToProps() {
  return {
  };
}

// These are prop injectors
export default compose(
  QDialogs(),
  withStyles(styles),  // creates this.props.classes
)(connect(mapStateToProps, mapDispatchToProps)(ReconcilePanel));

